import _objectSpread from "/data/jenkins/workspaces/workspace/h5/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import userName from './components/userName';
import phone from './components/phone';
import oaProbe from './components/oaProbe';
import PrivacyCom from '@/components/privacy';
import ProtocolCom from '@/components/protocol';
export default {
  components: {
    userName: userName,
    phone: phone,
    oaProbe: oaProbe,
    PrivacyCom: PrivacyCom,
    ProtocolCom: ProtocolCom
  },
  computed: _objectSpread({}, mapGetters(['currentLoginType', 'serviceUrl', 'appConfig', 'appConfigValid'])),
  created: function created() {
    // 检查是否已经登陆，已登陆，跳转到目标地址
    this.serviceUrl && (window.location.href = this.serviceUrl);
  },
  mounted: function mounted() {
    sessionStorage.setItem('step', '');
  }
};